module.exports = __webpack_public_path__ + "static/media/nevtattooLogo.f30628da.png";